export default {
    BK: '#000000',
    YE: '#ffff00',
    WH: '#ffffff',
    GN: '#008000',
    BU: '#0000ff',
    RD: '#ff0000',
    SR: '#c0c0c0',
    OG: '#ffa500',
    GY: '#808080',
    VT: '#A146FF',
    BE: '#D1BC8A',
    BN: '#5B3A29',
    IV: '#BD8F51',
    OL: '#6B7232',
    TQ: '#30D5C8',
    TR: 'transparent'
};
